"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _componentsBase = require("@telus-uds/components-base");
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const {
  useItemPositions
} = _componentsBase.horizontalScrollUtils;
const VideoSlider = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children
  } = _ref;
  const viewport = (0, _componentsBase.useViewport)();
  const [itemPositions] = useItemPositions();
  const [containerWidth, setContainerWidth] = _react.default.useState(null);
  const {
    previousIcon: PreviousIcon,
    nextIcon: NextIcon
  } = (0, _componentsBase.useThemeTokens)('VideoPickerSlider');
  const onLayout = _ref2 => {
    let {
      nativeEvent: {
        layout: {
          width
        }
      }
    } = _ref2;
    setContainerWidth(width);
  };
  const itemsGap = 32; // '5' on spacing scale
  const itemsCount = viewport === 'lg' || viewport === 'xl' ? 4 : 3;
  const itemGapPortioned = (itemsCount - 1) * itemsGap / itemsCount;
  const itemWidth = containerWidth === null ?
  // For first render, we don't know container width, so avoid flicker with static % width
  `calc(${Math.round(100 / itemsCount)}% - ${Math.round(itemGapPortioned)}px)` :
  // After first render, can't use % widths because parent is > 100% width horizontal scroll area
  Math.max(containerWidth / itemsCount - itemGapPortioned, 0 // Prevent negative width breaking layout on very narrow containers
  );
  const content = /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.StackView, {
    space: 5,
    direction: "row",
    accessibilityRole: "radiogroup",
    tokens: {
      flexGrow: 1
    },
    children: _react.default.Children.map(children, (child, index) => /*#__PURE__*/_react.default.cloneElement(child, {
      index,
      itemPositions,
      width: itemWidth
    }))
  });
  const overflow = containerWidth === null && {
    overflow: 'hidden'
  };
  const horizontalScrollTokens = {
    nextIcon: NextIcon,
    previousIcon: PreviousIcon,
    gutter: 0,
    borderBottomWidth: 0,
    borderBottomColor: 'transparent',
    buttonClearance: 0
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    onLayout: onLayout,
    style: overflow,
    ref: ref,
    children: containerWidth === null ?
    // Use a 100% width non-scrollable parent until containerWidth is known, to avoid flicker
    content : /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.HorizontalScroll, {
      ScrollButton: _componentsBase.HorizontalScrollButton,
      itemPositions: itemPositions,
      tokens: horizontalScrollTokens,
      children: content
    })
  });
});
VideoSlider.displayName = 'VideoSlider';
VideoSlider.propTypes = {
  children: _propTypes.default.node
};
var _default = exports.default = VideoSlider;